import React, { useState, useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const SettingsNotification = (props) => {
  const location = useLocation();
  const [mounted, setMounted] = useState(false);
  const { setSettingsNotification } = props;

  const closeNotification = (e) => {
    setSettingsNotification(false);
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    mounted && closeNotification();
  }, [location.pathname]);

  return (
    <div className="settings-notification">
      <div className="notification-msg">{"Your profile has been updated!"}</div>
      <img
        className="close-icon"
        onClick={closeNotification}
        src={"https://static.bigbrain.gg/assets/ugg/icons/close-white.svg"}
        alt="Close"
      />
    </div>
  );
};

export default SettingsNotification;
